export default {"src":"/_next/static/media/magellan.f52f8671.svg","height":36,"width":119,"blurWidth":0,"blurHeight":0};